/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import { throttle, get } from 'lodash';

const Carousel = ({ slides = [], periodTimeInMs = 8000, transitionInMs = 2000, interleave = true }) => {
  const sliderRef = useRef(null);
  const slidesToTransition = [...slides, slides[0]];

  let currentSlide = 0;
  let windowWidth;

  const [state, setState] = useState({
    transitionInMs,
    translateX: 0,
  });

  const slideToLeft = () => {
    currentSlide += 1;

    setState({
      transitionInMs,
      translateX: interleave
        ? -(currentSlide * 2 * sliderRef.current.offsetWidth)
        : -(currentSlide * sliderRef.current.offsetWidth),
    });

    if (currentSlide === slidesToTransition.length - 1) {
      currentSlide = 0;
    }
  };

  const onTransitionEnd = () => {
    if (currentSlide === 0) {
      setState({
        transitionInMs: 0,
        translateX: 0,
      });
    }
  };

  const onResize = () => {
    if (windowWidth !== get(window, 'innerWidth')) {
      currentSlide = 0;
      windowWidth = get(window, 'innerWidth');

      setState({
        transitionInMs: 0,
        translateX: 0,
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(slideToLeft, periodTimeInMs);
    const transitionEndEventListener = sliderRef.current.addEventListener('transitionend', onTransitionEnd);
    const resizeEventListener = window.addEventListener('resize', throttle(onResize, 150));
    windowWidth = get(window, 'innerWidth');

    return () => {
      clearInterval(interval);
      sliderRef.current.removeEventListener('transitionend', transitionEndEventListener);
      sliderRef.current.removeEventListener('resize', resizeEventListener);
    };
  }, []);

  return (
    <div className="w-full overflow-hidden">
      <div
        className="flex"
        style={{
          transform: `translateX(${state.translateX}px)`,
          transition: `transform ${state.transitionInMs}ms`,
        }}
        ref={sliderRef}
      >
        {slidesToTransition.map(slide =>
          interleave ? (
            <>
              <div className="w-full flex justify-center flex-none">{slide}</div>
              <div className="w-full flex-none" />
            </>
          ) : (
            <div className="w-full flex-none">{slide}</div>
          ),
        )}
      </div>
    </div>
  );
};

export default Carousel;
